var map = {
	"./black/zhuapaijilu2.png": "/hp4",
	"./blue/zhuapaijilu2.png": "CuMR",
	"./white/zhuapaijilu2.png": "KFy4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bP+d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/zhuapaijilu2\.png$
// module id = bP+d
// module chunks = 24